import { PostHog } from "posthog-js";
import { BookingMachine } from "./CreateBookingMachineV2";
import { usePostHog } from "posthog-js/react";
import { useMemo } from "react";
import { serializify } from "@greeter/json";

type CleanUpFn = () => void;

/**
 * Looks for potentially identifiable props and anonymizes them.
 *
 * This will deeply recurse through the object untill all properties have been checked.
 */
async function anonymizeData(obj: any) {
  for (const [k, v] of Object.entries(obj)) {
    if (typeof v === "object") {
      anonymizeData(v);
    }
  }
}

export function posthogAnonymousAnalyticsPlugin(
  m: BookingMachine,
  posthog: PostHog
): CleanUpFn {
  posthog.resetGroups();
  posthog.group("venue", "venues:" + m.getSnapshot().context.venueId, {
    venueId: m.getSnapshot().context.venueId,
    venueName: m.getSnapshot().context.venue?.name,
  });
  const s = m.on("*", (d) => {
    const hasErrorInType = (
        d.type.search("failed") >= 0 ||
        d.type.search("err")    >= 0 ||
        d.type.search("error")  >= 0
    );
    const hasErrorInBody =
      "error" in d &&
      d.error instanceof Error

    if (hasErrorInType && hasErrorInBody) {
      posthog.captureException(d.error);
    }

    posthog.capture(d.type, serializify(d), {
      transport: "sendBeacon",
    });
  });

  return s.unsubscribe;
}

export function useAnonymousAnalyticsPlugin(m: BookingMachine) {
  const posthog = usePostHog();
  useMemo(() => posthogAnonymousAnalyticsPlugin(m, posthog), [m, posthog]);
}
